"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp, Building2, Globe } from "lucide-react";
export default function 当社の専門知識() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    icon: TrendingUp,
    title: "ベトナム市場進出コンサルティング",
    ref: card1Ref,
    isVisible: card1Visible,
    delay: "0ms"
  }, {
    icon: Building2,
    title: "投資・会社設立サポート",
    ref: card2Ref,
    isVisible: card2Visible,
    delay: "200ms"
  }, {
    icon: Globe,
    title: "輸出支援",
    ref: card3Ref,
    isVisible: card3Visible,
    delay: "400ms"
  }];
  return <section className="bg-dark-background py-24 px-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground-dark md:text-5xl">
            当社の専門知識
          </h2>
          <p className="mt-4 text-lg text-foreground-dark/80">
            Nhật Minh Khang & Partners Co., Ltd.が提供する包括的なサービス
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={service.ref} style={{
            opacity: service.isVisible ? 1 : 0,
            transform: service.isVisible ? "translateY(0)" : "translateY(2rem)",
            transition: `opacity 350ms var(--ease-smooth) ${service.delay}, transform 350ms var(--ease-smooth) ${service.delay}`
          }}>
                <Card className="group h-full border border-border/20 bg-primary-light shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-strong">
                  <CardHeader className="flex flex-col items-center gap-4 text-center">
                    <div className="flex h-20 w-20 items-center justify-center rounded-lg bg-accent/10 text-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:bg-accent/20 group-hover:text-accent-hover group-hover:shadow-[0_0_20px_rgba(255,215,0,0.4)]">
                      <Icon className="h-10 w-10" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground-secondary">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center text-foreground-secondary/80">
                    プロフェッショナルなサポートで、御社のベトナム進出を成功へと導きます。
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}